import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { message } from 'antd';

import { getOrderByExternalId, codProductOrderDetails } from '../../api/api';
import { getValidateUrl } from '../../api/apigeeApi';

import PaymentOption from '../PaymentOption/PaymentOption';
import CardPayment from './CardPayment/CardPayment';
import ApplePayment from './ApplePayment/ApplePayment';

import './Payment.scss';

const win: any = window;

interface Props {
    rtl: boolean;
}

const Payment = ({ rtl }: Props) => {
    const xCoId: any = new URL(window.location.href).searchParams.get("xCoId");
    const oId: any = new URL(window.location.href).searchParams.get("oId");

    const [current, setCurrent] = useState('mada');
    const [shoppingCart, setShoppingCart] = useState(null);
    const [codReferenceId, setCodReferenceId] = useState('');
    const [loading, setLoading] = useState(false);
    const [selectRadioOption, setSelectRadioOption] = useState('card');

    const Error = (msg: string) => message.error(msg, 3);
    const { t } = useTranslation();

    useEffect(() => {
        const referenceId: string | null = new URL(window.location.href).searchParams.get("key");
        const orderId: any = win['orderId'] || oId;

        console.log('xCoId', xCoId);
        console.log('orderId', orderId);

        if (referenceId !== '' && referenceId !== null) {
            getValidateUrl(referenceId, xCoId)
                .then(res => {
                    if (res.status === 200) {
                        setCodReferenceId(res.data.params[0].value)
                    } else {
                        Error(res.data.status[`${rtl ? 'arabic' : 'english'}Detail`]);
                        setLoading(false);
                        setTimeout(() => {
                            window.location = win['errorPageURL'];
                        }, 1000);
                    }
                }).catch(e => {
                    setLoading(false);
                    Error(e.message);
                    setTimeout(() => {
                        window.location = win['errorPageURL'];
                    }, 1000);
                });
        } else {
            // normal e commerce payment

            if (orderId !== "" && orderId) {
                const returnUrl: any = `${win['returnUrl']}&status=failure`;

                getOrderByExternalId(orderId, xCoId)
                    .then(res => {
                        if (res.status === 200) {
                            window.localStorage.removeItem('emailID');
                            window.localStorage.removeItem('codId');
                            setLoading(false);
                            setShoppingCart(res.data.shoppingCart);
                            window.localStorage.setItem("codId", orderId)
                            window.localStorage.setItem("emailID", res.data?.dpData?.dpRequest?.OrderBody?.CustomerOrder?.email)
                        } else {
                            Error(res.data.status[`${rtl ? 'arabic' : 'english'}Detail`]);
                            setLoading(false);
                            setTimeout(() => {
                                window.location = returnUrl;
                            }, 1000);
                        }
                    }).catch(e => {
                        setLoading(false);
                        Error(e.message);
                        setTimeout(() => {
                            window.location = returnUrl;
                        }, 1000);
                    })
            }
        }
    }, [rtl, xCoId]);

    useEffect(() => {
        if (codReferenceId !== "") {
            codProductOrderDetails(codReferenceId, xCoId)
                .then(res => {
                    if (res.data.status.statusCode === "MBE_000") {
                        setLoading(false);
                        window.location.href = `${win['cod_redirect_page_url']}?oId=${res.data.data.orderId}&pId=${res.data.data.paymentTransactionId}&transId=${res.data.data.transactionId}`
                    } else {
                        Error(res.data.errorCode);
                        setTimeout(() => {
                            window.location = win['errorPageURL'];
                        }, 1000);
                        setLoading(false);
                    }
                }).catch((e) => {
                    setLoading(false);
                    setTimeout(() => {
                        window.location = win['errorPageURL'];
                    }, 1000);
                    Error(e.message)
                })
        }
    }, [codReferenceId, rtl, xCoId])

    const handleCardOption = (value: any) => {
        setCurrent(value)
    }

    const handlePaymentOptionChange = (value: string) => {
        setSelectRadioOption(value)
    }

    return (
        <div className={rtl ? 'container Payment__Container PC__right' : 'container Payment__Container'}>
            <div className='row'>
                <div className='Payment__title'>{t("Payment")}</div>
                <PaymentOption
                    rtl={rtl}
                    selectRadioOption={selectRadioOption}
                    handlePaymentOptionChange={handlePaymentOptionChange}
                />

                <CardPayment
                    rtl={rtl}
                    current={current}
                    loading={loading}
                    shoppingCart={shoppingCart}
                    handleCardOption={handleCardOption}
                    selectRadioOption={selectRadioOption}
                />

                <ApplePayment
                    rtl={rtl}
                    shoppingCart={shoppingCart}
                    selectRadioOption={selectRadioOption}
                />

            </div>
        </div>
    )
}

export default Payment;
